import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { GknRoutePath } from 'src/app/app-routing.enum';
import { RecentlyViewedFacetComponent } from '../../../search-results/headless-search/recently-viewed-facet/recently-viewed-facet.component';
import { RecentlySearchFacetComponent } from '../../../search-results/headless-search/recently-search-facet/recently-search-facet.component';

@Component({
    selector: 'app-search-suggestions',
    templateUrl: './search-suggestions.component.html',
    styleUrls: ['./search-suggestions.component.scss'],
    imports: [
        CommonModule,
        RecentlySearchFacetComponent,
        RecentlyViewedFacetComponent,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatInputModule,
    ],
})
export class SearchSuggestionsComponent {
    private router = inject(Router);

    /** Flag to control visibility of the suggestions panel */
    @Input() isVisible: boolean = false;
    /** Array of Coveo suggestions (future feature) */
    @Input() suggestions: any[] = [];
    /** Flag to show/hide Coveo suggestions (future feature) */
    @Input() showCoveoSuggestions: boolean = false;
    /** Configurable top position for the suggestions panel */
    @Input() topPosition: string = '100px';
    /** Event emitted when the suggestions panel should be closed */
    @Output() closePanel = new EventEmitter<void>();

    /**
     * Handle facet item click event from recently viewed or recently searched facets.
     * Closes the suggestions panel and optionally navigates to search page with query param.
     * @param openRecentlyViewed - If true, navigates to search page with openRecentlyViewed query param
     */
    onFacetItemClick(openRecentlyViewed: boolean = false): void {
        this.closePanel.emit();
        if (openRecentlyViewed) {
            this.router.navigate([`/${GknRoutePath.SEARCH}`], {
                queryParams: { openRecentlyViewed: 'true' },
                queryParamsHandling: 'merge',
            });
        }
    }
}
